var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DEFORMER_MANIP_ENUM, TEXT_TRANSFORM_ENUM } from "../enums";
import { average } from "../../utils";
import { TextDeformer } from "./TextDeformer";
var TextTransformDeformer = /** @class */ (function (_super) {
    __extends(TextTransformDeformer, _super);
    function TextTransformDeformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deformerType = [DEFORMER_MANIP_ENUM.MATRIX];
        _this._transforms = [0.0, 0.0];
        _this._scales = [1.0, 1.0];
        _this._scaleAnchors = [];
        _this._weights = [];
        return _this;
    }
    TextTransformDeformer.prototype._uniforms = function () {
        return {
            uTransforms: this.transforms,
            uScales: this.scales,
            uScaleAnchors: this._scaleAnchors,
        };
    };
    TextTransformDeformer.prototype._vertexHeader = function () {
        var transformCount = this.transforms.length / 2;
        return "\n        attribute float aWeight;\n        uniform vec2 uTransforms[".concat(transformCount, "];\n        uniform vec2 uScales[").concat(transformCount, "];\n        uniform vec2 uScaleAnchors[").concat(transformCount, "];\n        ");
    };
    TextTransformDeformer.prototype._vertBody = function () {
        return "\n        mat3 getTranslationMatrix".concat(this.index, "() {\n            int transformIndex = int(aWeight);\n            vec2 vertexOffset = uTransforms[transformIndex];            \n            mat3 moveMatrix = mat3(1, 0, 0, 0, 1, 0, vertexOffset.x, vertexOffset.y, 1);\n            \n            // scale vertex from scale anchor position using scale value\n            vec2 vertexScale = uScales[transformIndex];\n            mat3 scaleMatrix = mat3(vertexScale.x, 0, 0, 0, vertexScale.y, 0, 0, 0, 1);\n            vec2 vertexScaleAnchor = uScaleAnchors[transformIndex];\n            mat3 scaleAnchorMatrix = mat3(1, 0, 0, 0, 1, 0, vertexScaleAnchor.x, vertexScaleAnchor.y, 1);\n            mat3 invScaleAnchorMatrix = mat3(1, 0, 0, 0, 1, 0, -vertexScaleAnchor.x, -vertexScaleAnchor.y, 1);\n            \n            mat3 combinedMatrix = moveMatrix * scaleAnchorMatrix * scaleMatrix * invScaleAnchorMatrix;\n            return combinedMatrix;\n        }\n        ");
    };
    /**
     * When the transform type changes, we need to reset the state of the deformer as we need all of our
     * internal data to match with the new transform type.
     */
    TextTransformDeformer.prototype._resetStateOnProperties = function (expectedLength) {
        // this._opacities = new Array(expectedLength).fill(1.0);
        this._transforms = new Array(expectedLength * 2).fill(0.0);
        this._scales = new Array(expectedLength * 2).fill(1.0);
    };
    Object.defineProperty(TextTransformDeformer.prototype, "transforms", {
        get: function () {
            return this._transforms;
        },
        set: function (value) {
            this._validateData(value, 2);
            this._transforms = value;
            // console.log(this.parent.shader.uniforms);
            // this.parent.shader.uniforms.uTransforms = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextTransformDeformer.prototype, "scales", {
        get: function () {
            return this._scales;
        },
        set: function (value) {
            this._validateData(value, 2);
            this._scales = value;
        },
        enumerable: false,
        configurable: true
    });
    TextTransformDeformer.prototype._updateProperties = function () {
        _super.prototype._updateProperties.call(this);
        this._generateScaleAnchors();
    };
    TextTransformDeformer.prototype._generateScaleAnchors = function () {
        var anchors = [];
        switch (this.transformType) {
            case TEXT_TRANSFORM_ENUM.BOUNDS:
                anchors = [this._generateBoundScaleAnchors()];
                break;
            case TEXT_TRANSFORM_ENUM.LINE:
                anchors = this._generateLineScaleAnchors();
                break;
            case TEXT_TRANSFORM_ENUM.WORD:
                anchors = this._generateWordScaleAnchors();
                break;
            case TEXT_TRANSFORM_ENUM.GLYPH:
                anchors = this._generateGlyphScaleAnchors();
                break;
        }
        this._scaleAnchors = anchors.flatMap(function (item) { return [item.x, item.y]; });
    };
    Object.defineProperty(TextTransformDeformer.prototype, "scaleAnchors", {
        get: function () {
            return this._scaleAnchors;
        },
        enumerable: false,
        configurable: true
    });
    TextTransformDeformer.prototype._generateBoundScaleAnchors = function () {
        var _a = this.parent.getBounds(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        return {
            x: x + (width / 2),
            y: y + (height / 2),
        };
    };
    // TODO: specify type of position for anchor {x, y}
    TextTransformDeformer.prototype._generateLineScaleAnchors = function () {
        var scaleAnchors = [];
        var lineRanges = this.parent.lineGlyphRanges();
        for (var lineIndex = 0; lineIndex < lineRanges.length; lineIndex++) {
            var lineStart = lineRanges[lineIndex][0];
            var lineEnd = lineRanges[lineIndex][1];
            var scaleAnchor = average(this.parent._fontAtlasTextGeometry._getGlyphCenter(lineStart), this.parent._fontAtlasTextGeometry._getGlyphCenter(lineEnd));
            scaleAnchors.push(scaleAnchor);
        }
        return scaleAnchors;
    };
    TextTransformDeformer.prototype._generateWordScaleAnchors = function () {
        var scaleAnchors = [];
        var wordRanges = this.parent.words;
        for (var wordIndex = 0; wordIndex < wordRanges.length; wordIndex++) {
            var wordRange = wordRanges[wordIndex];
            var wordStart = wordRange[0];
            var wordEnd = wordRange[wordRange.length - 1];
            var scaleAnchor = average(this.parent._fontAtlasTextGeometry._getGlyphCenter(wordStart), this.parent._fontAtlasTextGeometry._getGlyphCenter(wordEnd));
            scaleAnchors.push(scaleAnchor);
        }
        return scaleAnchors;
    };
    TextTransformDeformer.prototype._generateGlyphScaleAnchors = function () {
        var _this = this;
        return this.parent.glyph.map(function (glyph, index) { return _this.parent._fontAtlasTextGeometry.getGlyphCenter(index); });
    };
    return TextTransformDeformer;
}(TextDeformer));
export { TextTransformDeformer };
